import { Skeleton } from '@nextui-org/react';

const SkeletonListDecor = () => {
  const arr = Array.from(Array(10).keys());

  return (
    <div className="grid grid-cols-5 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-4 sm:gap-3 mb-10">
      {arr.map((item) => (
        <div key={item} className="border-2 overflow-hidden border-gray-200 rounded-xl">
          <div className="relative bg-gray-50 flex items-center justify-center overflow-hidden before:pb-[100%] before:block">
            <Skeleton className="w-[130px] h-[130px] sm:w-[95px] sm:h-[95px] rounded-full" />
          </div>
          <div className="p-4 sm:p-3">
            <Skeleton className="w-full h-6 rounded-md" />
            <div className="flex justify-between items-center mt-4 sm:mt-3">
              <Skeleton className="w-[70px] sm:w-[40px] h-6 rounded-md" />
              <Skeleton className="w-[70px] sm:w-[40px] h-6 rounded-md" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SkeletonListDecor;
